import styled from 'styled-components';
import { Table } from './table';
export const MiniTable = styled(Table)`
  .ant-table-thead > tr > th {
    background: transparent;
    padding: 0 8px;
  }
  .ant-table-tbody > tr > th,
  .ant-table-tbody > tr > td {
    border-bottom: none;
  }
`;
